import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

import { SwitchAlgorithmFacade } from './switch-algorithm.facade';
import { AlgorithmSwitcherComponent } from './algorithm-switcher.component';
import { AlgorithmUsageGridComponent } from '../widgets/usage-grid/usage-grid.component';

@Component({
  selector: 'ts-pipeline-algorithm-switcher',
  templateUrl: './pipeline-algorithm-switcher.component.html',
  styleUrls: ['./pipeline-algorithm-switcher.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatButtonModule, TranslateModule, AlgorithmSwitcherComponent, AlgorithmUsageGridComponent],
})
export class PipelineAlgorithmSwitcherComponent {
  constructor(private readonly facade: SwitchAlgorithmFacade) {}

  public readonly data$ = this.facade.data$;
  public readonly pipelineName$ = this.facade.pipelineName$;
  public readonly readyToSwitch$ = this.facade.readyToSwitch$;

  cancel() {
    this.facade.cancel();
  }

  accept() {
    this.facade.accept();
  }
}
